module.exports = {
  image: {
    deal_config: {
      compress_quality: '',
      cut_config: {
        height: '',
        position: '',
        width: ''
      },
      is_compress: 0,
      is_cut: 0,
      is_zoom: 0,
      is_fix_scale: 0,
      type: 10,
      fix_scale_config: [],
      zoom_config: {
        height: '',
        width: ''
      }
    },
    display_config: {
      form_display: {
        height: '',
        width: ''
      },
      list_display: {
        height: '',
        width: ''
      },
      suspension_type: [10]
    },
    mobile_config: {
      from: '',
      readonly_size_form: {
        height: '',
        width: ''
      }
    },
    size_limit: {
      height: {
        config: [],
        is_limited: 0
      },
      size: {
        config: '',
        is_limited: 0
      },
      width: {
        config: [],
        is_limited: 0
      }
    },
    thumb_config: {
      config: [
        {
          height: '',
          width: '',
          thumb_type: ''
        }
      ],
      is_thumb: 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/photo.js